import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import LandingFeatures from '../components/LandingFeatures';
import HowItWorks from '../components/HowItWorks';

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <Hero />
        
        {/* Value Prop Highlight - Matching consistency across all products */}
        <section className="py-24 bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">
              Your Guest's Perspective. <span className="text-indigo-600">Perfectly Captured.</span>
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
              Don't rely on a single photographer to tell the whole story. Memories empowers every guest to contribute to a shared, high-quality gallery that lives forever.
            </p>
            <div className="flex justify-center">
              <div className="bg-indigo-50 px-12 py-8 rounded-2xl border border-indigo-100 max-w-lg">
                <p className="text-indigo-600 font-black text-5xl mb-2">100%</p>
                <p className="text-indigo-900 font-bold uppercase tracking-wider text-sm">GUEST PARTICIPATION RATE POTENTIAL</p>
              </div>
            </div>
          </div>
        </section>

        <LandingFeatures />
        <HowItWorks />
      </main>
    </div>
  );
};

export default LandingPage;